import { CurrencyJpyIcon } from './CurrencyJpyIcon';

/**
 * author: Google
 * id 639A8D4C-086C-4038-A569-F9387E851262
 * name currency-jpy
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-jpy.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const YenIcon = CurrencyJpyIcon;
export default YenIcon